// extracted by mini-css-extract-plugin
export var readonly = "_i1-1";
export var star = "_i1-0";